export type TCoordinate = {
  lat: number;
  lon: number;
};

interface ICalcCrow {
  from: TCoordinate;
  to: TCoordinate;
}

export const calcCrow = ({
  from: { lat: lat1, lon: lon1 },
  to: { lat: lat2, lon: lon2 },
}: ICalcCrow): number => {
  var r = 6371;
  var dLat = toRad(lat2 - lat1);
  var dLon = toRad(lon2 - lon1);
  var Lat1 = toRad(lat1);
  var Lat2 = toRad(lat2);

  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(Lat1) * Math.cos(Lat2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = r * c;
  return d;
};

// Converts numeric degrees to radians
function toRad(Value: number): number {
  return (Value * Math.PI) / 180;
}
